import React from 'react';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { DatePicker } from '@material-ui/pickers';
import { format } from 'date-fns';


const TimelineDatePicker = ({
  label,
  name,
  value,
  disabled = false,
  setFieldValue,
  handleBlur,
  touched,
  errors
}) => {
  return (
    <>
      <div className="mb-1 text-muted text-12">
        {label}
      </div>
      <DatePicker
        autoOk
        disablePast
        disabled={disabled}
        variant="inline"
        format="MM-dd-yyyy"
        name={name}
        placeholder="mm-dd-yyyy"
        value={value}
        onChange={(date) => {
          let dateWithTime;

          if (name === 'startDate') {
            dateWithTime = format(date, 'yyyy-MM-dd 00:00:00');
          } else {
            dateWithTime = format(date, 'yyyy-MM-dd 23:59:59');
          }

          setFieldValue(name, dateWithTime);
        }}
        onBlur={handleBlur}
        inputVariant="outlined"
        InputProps={{
          endAdornment: (
            <CalendarTodayIcon className="text-muted ml-2 text-18" />
          )
        }}
        error={touched[name] && Boolean(errors[name])}
        helperText={touched[name] && errors[name]}
      />
    </>
  );
};

export default TimelineDatePicker;
